import { useCallback, useContext, useEffect } from 'react';

import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { PAYMENT_SERVICES } from '@app/dev/constants/enums/paymentServices';
import ToastWrapper from '@common/helpers/toastWrapper';
import { PopupContext } from '@app/dev/contexts/popup';

const PaymentServicesTypeKeyMap = {
  [PAYMENT_SERVICES.SAFEWAY]: {
    Type: 'pix'
  },
  [PAYMENT_SERVICES.PAYBROKERS]: {
    pix_key_type: 'CPF'
  },
  [PAYMENT_SERVICES.PARAI]: {
    pix_key_type: 'CPF'
  },
}

export const CashoutByPix = ({
  amount,
  cashoutMethod
}) => {
  const [{ closePopup }] = useContext(PopupContext);

  const makeCashout = useCallback(async () => {
    const req = {
      amount: +amount,
      service: PAYMENT_SERVICES[cashoutMethod.service],
      payee: {
        forProduct: 'sport',
        ...PaymentServicesTypeKeyMap[PAYMENT_SERVICES[cashoutMethod.service]]
      },
    };

    const res = await swarmRequest(req, 'withdraw_v2');

    if (res.status === 'error')
      ToastWrapper('error', res.message)
    else
      ToastWrapper('success', 'Your payment was successfully done')

    closePopup();
  }, [amount, cashoutMethod.service, closePopup]);

  useEffect(() => {
    makeCashout();
  }, [makeCashout]);

  return null;
};
